import Vue from 'vue';
import Router from 'vue-router';
import index from '@/pages/index';

import { wechatLogin, wechatOpenid, wechatUnionId } from '@/api/wechat';
import { tokenChangeLogin, isLogin, getSessionByToken, getFullPath, tokenLoginChange,isMaster } from '@/api/login';
import storage from '@/utils/storage';
import { cookieUtils } from '../utils/cookieUtils';
import { getQueryString, isGomeHome,isSource, iszkl } from '../utils/util.js';
import { golbalConstants } from '@/constants/constants';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: __dirname,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
    routes: [
        //短期活动：2019尊享e生（妈妈版）
        {
            path: '/shortTermActivity/holeLifeForMather',
            name: 'holeLifeForMather',
            component: resolve => require(['./../pages/shortTermActivity/holeLifeForMather.vue'], resolve)
        },
        //京康源信息填写页面
        {
            path: '/insured/bjrsJKY',
            name: 'insuredBjrsJKY',
            component: resolve => require(['./../pages/insured/bjrsJKY.vue'], resolve)
        },
        {
            path :'/agreement',
            name: 'Agreement',
            component: resolve => require(['../pages/agreement/agreement.vue'], resolve),
        },
        {
            path :'/rule',
            name: 'rule',
            component: resolve => require(['../pages/rule/rule.vue'], resolve),
        },
        // 对接pass登录需求
        {
            path: '/login/passUnify',
            component: resolve => require(['../pages/login/PassLogin20190318/Index.vue'], resolve),
            children: [
                { path: '/', name: 'passUnifyLogin', component: resolve => require(['../pages/login/PassLogin20190318/LoginAndRegister.vue'], resolve) },
                { path: 'password/:type', name: 'LoginPassword', component: resolve => require(['../pages/login/PassLogin20190318/LoginPassword.vue'], resolve) },
                { path: 'SMS/:type', name: 'LoginForSMS', component: resolve => require(['../pages/login/PassLogin20190318/LoginForSMS.vue'], resolve) },
            ]
        },
        //对接代理人平台
        {
            path: '/agent',
            component: resolve => require(['../pages/agent/Index.vue'], resolve),
            children: [
                { path: 'personalInfo', name: 'PersonalInfo', component: resolve => require(['../pages/agent/PersonalInfo.vue'], resolve) },
                { path: 'personalInfoSure', name: 'PersonalInfoSure', component: resolve => require(['../pages/agent/PersonalInfoSure.vue'], resolve) },
                { path: 'idCardUpdate', name: 'idCardUpdate', component: resolve => require(['../pages/agent/idCardUpdate.vue'], resolve) },
                { path: 'larger', name: 'larger', component: resolve => require(['../pages/agent/larger.vue'], resolve) },
                { path: 'auditResult', name: 'auditResult', component: resolve => require(['../pages/agent/auditResult3.vue'], resolve) },
                { path: 'agentInvite', name: 'agentInvite', component: resolve => require(['../pages/agent/agentInvite.vue'], resolve) },
            ]
        },
        //修改手机号
        {
            path: '/changePhone',
            component: resolve => require(['../pages/changePhone/Index.vue'], resolve),
            children: [
                { path: 'chooseType', name: 'ChooseType', component: resolve => require(['../pages/changePhone/chooseType.vue'], resolve) },
                { path: 'checkPassword', name: 'CheckPassword', component: resolve => require(['../pages/changePhone/checkPassword.vue'], resolve) },
                { path: 'inputPhone', name: 'InputPhone', component: resolve => require(['../pages/changePhone/inputPhone.vue'], resolve) },
                { path: 'checkSMS', name: 'CheckSMS', component: resolve => require(['../pages/changePhone/checkSMS.vue'], resolve) },

            ]
        },
        //合作三方平台公示
        {
            path: '/publicity',
            component: resolve => require(['../pages/publicity/Index.vue'], resolve),
            children: [
                { path:'publicity', name:'Publicity', component: resolve => require(['../pages/publicity/publicity.vue'], resolve) },
                { path:'publicityList', name:'PublicityList', component: resolve => require(['../pages/publicity/publicityList.vue'], resolve) },
            ]
        },

        // 规则及服务保障
        {
            path: '/ruleService/ruleService',
            name: 'ruleService',
            component: resolve => require(['../pages/ruleService/ruleService.vue'], resolve)
        },


        //阳光赠险(出行)
        {
            path: '/activity/giveYg',
            name: 'activityGiveYg',
            component: resolve => require(['../pages/activity/giveYg.vue'], resolve)
        },
        //阳光赠险(重疾)
        {
            path: '/activity/giveZj',
            name: 'activityGiveZj',
            component: resolve => require(['../pages/activity/giveZj.vue'], resolve)
        },
        //
        {
            path: '/activity/epidemicList',
            name: 'activityEpidemicList',
            component: resolve => require(['../pages/activity/epidemicList.vue'], resolve)
        },
        //京康源信息填写页面
        {
            path: '/insured/bjrsJKY',
            name: 'insuredBjrsJKY',
            component: resolve => require(['./../pages/insured/bjrsJKY.vue'], resolve)
        },
        //永诚财险填写页面
        {
            path: '/insured/productYccx',
            name: 'productYccx',
            component: resolve => require(['./../pages/insured/productYccx.vue'], resolve)
        },
        // 法律和隐私政策
        {
            path: '/login/lowAndPrivacyPolicy',
            name: 'lowAndPrivacyPolicy',
            component: resolve => require(['../pages/login/lowAndPrivacyPolicy.vue'], resolve),
        },
        // 用户注册国美保险经纪服务协议
        {
            path: '/login/serviceProtocol',
            name: 'serviceProtocol',
            component: resolve => require(['../pages/login/gomePlatformServiceProtocol.vue'], resolve),
        },
        { // 信息确认页
            path: '/insured/confirm/:confirmSubmitId',
            name: 'insuredconfirmData',
            component: resolve => require(['./../pages/insured/confirmData.vue'], resolve)
        },
        { // 信息确认页
            path: '/insured/confirmTK/:confirmSubmitId',
            name: 'insuredconfirmData',
            component: resolve => require(['./../pages/insured/confirmDataTK.vue'], resolve)
        },
        { // 信息确认页
            path: '/insured/confirmTwo/:confirmSubmitId',
            name: 'insuredconfirmDataTwo',
            component: resolve => require(['./../pages/insured/confirmDataTwo.vue'], resolve)
        },
        { // 改版后信息确认页
            path: '/insured/newConfirm/:confirmSubmitId',
            name: 'insuredNewConfirmDataTwo',
            component: resolve => require(['./../pages/insured/newConfirm.vue'], resolve)
        },
        { // 身份证上传页面
            path: '/insured/idCardUpload/:type',
            name: 'insuredIdCardUpload',
            component: resolve => require(['./../pages/insured/insuredIdCardUpload.vue'], resolve)
        },
        { // 投连身份证上传页面
            path: '/insured/toulianIdCardUpload/:type',
            name: 'toulianIdCardUpload',
            component: resolve => require(['./../pages/insured/toulianIdCardUpload.vue'], resolve)
        },

        {
            path: '/activity/groupInsurance/insure',
            name: 'groupInsuranceInsure',
            component: resolve => require(['./../pages/activity/groupInsurance/insure.vue'], resolve)
        },
        {
            path:'/activity/notice',
            name:'notice',
            component: resolve => require(['../pages/activity/notice/notice.vue'], resolve)
        },
        {
            path: '/activity/internalWelfare',
            name: 'internalWelfare',
            component: resolve => require(['./../pages/activity/internalWelfare.vue'], resolve)
        },
        {
            path: '/activity/internalMell',
            name: 'internalMell',
            component: resolve => require(['./../pages/activity/internalMell.vue'], resolve)
        },
        {
            path: '/activity/worldCup/insured',
            name: 'worldCupInsured',
            component: resolve => require(['./../pages/activity/worldCup/insured.vue'], resolve)
        },
        {
            path: '/activity/worldCup/score',
            name: 'worldCuoScore',
            component: resolve => require(['./../pages/activity/worldCup/score.vue'], resolve)
        },
        {
            path: '/activity/worldCup',
            name: 'world-cup',
            component: resolve => require(['./../pages/activity/worldCup/worldCup.vue'], resolve)
        },
        {
            path: '/bindPlusMobile',
            name: 'bindPlusMobile',
            component: resolve => require(['./../pages/login/bindPlusMobile.vue'], resolve)
        },
        {
            path: '/activity/motherDay/poster',
            name: 'motherPoster',
            component: resolve => require(['./../pages/activity/motherDay/poster.vue'], resolve)
        },
        {
            path: '/activity/mtb/serp',
            name: 'mtbSerp',
            component: resolve => require(['./../pages/activity/mtb/serp.vue'], resolve)
        },
        {
            path: '/activity/mtb/answer',
            name: 'mtbAnswer',
            component: resolve => require(['./../pages/activity/mtb/answer.vue'], resolve)
        },
        {
            path: '/activity/mtb/home',
            name: 'mtbHome',
            component: resolve => require(['./../pages/activity/mtb/home.vue'], resolve)
        },
        {
            path: '/megaPrice/poster',
            name: 'megaPricePoster',
            component: resolve => require(['./../pages/activity/megaPrice/poster.vue'], resolve)
        },
        {
            path: '/activity/megaPrice',
            name: 'megaPrice',
            component: resolve => require(['./../pages/activity/megaPrice/megaPrice.vue'], resolve)
        },
        {
            path: '/activity/myAward',
            name: 'myAward',
            component: resolve => require(['../pages/activity/lottery/myAward.vue'], resolve)
        },
        {
            path: '/activity/rules',
            name: 'rules',
            component: resolve => require(['./../pages/activity/rules.vue'], resolve)
        },
        // {
        //     path: '/activity/writeAddress',
        //     name: 'writeAddress',
        //     component: resolve => require(['../pages/activity/lottery/address.vue'], resolve)
        // },
        {
            path: '/activity/carLottery',
            name: 'carLottery',
            component: resolve => require(['../pages/activity/lottery/carLottery.vue'], resolve)
        },
        {
            path: '/activity/stepNumber',
            name: 'stepNumber',
            component: resolve => require(['../pages/activity/eleven/stepNumber.vue'], resolve)
        },
        {
            path: '/activity/carGround',
            name: 'carGrounder',
            component: resolve => require(['../pages/activity/carJinChao/carGround.vue'], resolve)
        },
        {
            path: '/activity/carJinChao',
            name: 'carJinChao',
            component: resolve => require(['../pages/activity/carJinChao/carJinChao.vue'], resolve)
        },
        {
            path: '/activity/appointment',
            name: 'appointment',
            component: resolve => require(['../pages/activity/carJinChao/appointment.vue'], resolve)
        },
        {
            path: '/activity/appointSuccess',
            name: 'appointSuccess',
            component: resolve => require(['../pages/activity/carJinChao/appointSuccess.vue'], resolve)
        },
        {
            path: '/activity/poster',
            name: 'poster',
            component: resolve => require(['../pages/activity/carJinChao/poster.vue'], resolve)
        },
        {
            path: '/activity/carShare',
            name: 'carShare',
            component: resolve => require(['../pages/activity/carJinChao/activityShare.vue'], resolve)
        },
        {
            path: '/activity/elevenShare',
            name: 'elevenShare',
            component: resolve => require(['../pages/activity/eleven/share.vue'], resolve)
        },
        {
            path: '/activity/giveZa',
            name: 'activityGiveZa',
            component: resolve => require(['../pages/activity/giveZa.vue'], resolve)
        },
        {
            path: '/activity/giveZaPc',
            name: 'activityGiveZaPc',
            component: resolve => require(['./../pages/activity/givezaPc.vue'], resolve)
        },
        {
            path: '/activity/motherDay',
            name: 'activityMotherDay',
            component: resolve => require(['./../pages/activity/motherDay/motherDay.vue'], resolve)
        },
        {
            path: '/activity/guess',
            name: 'activityGuess',
            component: resolve => require(['../pages/activity/fifa/guess.vue'], resolve)
        },
        {
            path: '/toulian/redempPolicyDetail/:policyId',
            name: 'toulianRedempPolicyDetail',
            component: resolve => require(['../pages/customProduct/toulian/redempPolicyDetail.vue'], resolve)
        },
        {
            path: '/toulian/redemption',
            name: 'toulianRedemption',
            component: resolve => require(['../pages/customProduct/toulian/redemption.vue'], resolve)
        },
        {
            path: '/toulian/handlerDetail/:policyId',
            name: 'toulianHandlerDetail',
            component: resolve => require(['../pages/customProduct/toulian/handlerDetail.vue'], resolve)
        },
        {
            path: '/toulian/incomeDetail/:policyId',
            name: 'toulianIncomeDetail',
            component: resolve => require(['../pages/customProduct/toulian/incomeDetail.vue'], resolve)
        },
        {
            path: '/toulian/addDetail/:policyId',
            name: 'toulianAddDetail',
            component: resolve => require(['../pages/customProduct/toulian/addDetail.vue'], resolve)
        },
        {
            path: '/toulian/xuzhi',
            name: 'toulianUserXuzhi',
            component: resolve => require(['../pages/customProduct/toulian/xuzhi.vue'], resolve)
        },
        {
            path: '/toulian/riskAppraisal',
            name: 'riskAppraisal',
            component: resolve => require(['../pages/customProduct/toulian/riskAppraisal.vue'], resolve)
        },
        {
            path: '/toulian/income',
            name: 'income',
            component: resolve => require(['../pages/customProduct/toulian/income.vue'], resolve)
        },
        {
            path: '/toulian/payResult',
            name: 'payResult',
            component: resolve => require(['../pages/customProduct/toulian/payResult.vue'], resolve)
        },
        {
            path: '/toulian/pay',
            name: 'tlPay',
            component: resolve => require(['../pages/customProduct/toulian/tlPay.vue'], resolve)
        },
        {
            path: '/toulian/riskResult',
            name: '/riskResult',
            component: resolve => require(['../pages/customProduct/toulian/riskResult.vue'], resolve)
        },
        {
            path: '/insured/severeness',
            name: 'insuredSevereness',
            component: resolve => require(['./../pages/insured/severeness.vue'], resolve)
        },
        {
            path: '/insured/momBaby',
            name: 'insuredMomBaby',
            component: resolve => require(['./../pages/insured/momBaby.vue'], resolve)
        },
        {
            path: '/insured/benefitEnjoy',
            name: 'benefitEnjoy',
            component: resolve => require(['./../pages/insured/benefitEnjoy.vue'], resolve)
        },
        {
            path: '/insured/accountRisk',
            name: '/accountRisk',
            component: resolve => require(['../pages/insured/accountRisk.vue'], resolve)
        },
        {
            path: '/insured/healthNotification',
            name: '/healthNotification',
            component: resolve => require(['../pages/insured/healthNotification.vue'], resolve)
        },
        {
            path: '/insured/healthKnow',
            name: '/healthKnow',
            component: resolve => require(['../pages/insured/healthKnow.vue'], resolve)
        },
        {
            path: '/insured/healthKnowTK',
            name: '/healthKnowTK',
            component: resolve => require(['../pages/insured/healthyTK.vue'], resolve)
        },
        {
            path: '/toulian/insuredFormTl',
            name: 'insuredFormTl',
            component: resolve => require(['../pages/customProduct/toulian/insuredFormTl.vue'], resolve)
        },
        {
            path: '/insured/detail/:id',
            name: 'insuredDetail',
            component: resolve => require(['../pages/my/insuredDetail.vue'], resolve),
            meta: { requiresAuth: true }
        },
        // 信息披露页下的模块
        {
            path: '/productList/consumer',
            name: 'consumer',
            component: resolve => require(['../pages/three/productList/consumer.vue'], resolve),
            meta: { requireShow : true }
        },
        {
            path: '/productList/claim',
            name: 'claim',
            component: resolve => require(['../pages/three/productList/claim.vue'], resolve),
            meta: { requireShow : true }
        },
        {
            path: '/productList/basicInfo',
            name: 'basicInfo',
            component: resolve => require(['../pages/three/productList/basicInfo.vue'], resolve),
            meta: { requireShow : true }
        },
        {
            path: '/productList/partners',
            name: 'partners',
            component: resolve => require(['../pages/three/productList/partners.vue'], resolve),
            meta: { requireShow : true }
        },
        {
            path: '/productList/productBx',
            name: 'productBx',
            component: resolve => require(['../pages/three/productList/productBx.vue'], resolve),
            meta: { requireShow : true }
        },



        {
            path: '/productToulian/:code',
            name: 'productToulian',
            component: resolve => require(['../pages/customProduct/toulian/detail.vue'], resolve)
        },

        {
            path: '/toulian/otherDetaill/:code',
            name: 'otherDetail',
            component: resolve => require(['../pages/customProduct/toulian/otherDetail.vue'], resolve)
        },
        // 教育金
        {
            path: '/productEducationMoney/:code',
            name: 'productEducationMoney',
            component: resolve => require(['../pages/customProduct/toulian/educationMoney.vue'], resolve)
        },
        {
            path: '/childrenFundruleDetail',
            name: 'childrenFundruleDetail',
            component: resolve => require(['../pages/customProduct/childrenFundruleDetail.vue'], resolve)
        },
        {
            path: '/renewal/base/:id',
            name: 'renewalBase',
            component: resolve => require(['../pages/renewal/base.vue'], resolve),
            meta: { requiresAuth: true }
        },
        {
            path: '/insured/enjoyLife',
            name: 'insuredZaEnjoyLife',
            component: resolve => require(['../pages/insured/insuredZaEnjoyLife.vue'], resolve)
        },
        {
            path: '/insured/insuredMillionMedical',
            name: 'insuredMillionMedical',
            component: resolve => require(['../pages/insured/insuredMillionMedical.vue'], resolve)
        },
        {
            path: '/insured/formFollowCar',
            name: 'insuredFormFollowCar',
            component: resolve => require(['../pages/insured/formFollowCar.vue'], resolve)
        },
        {
            path: '/insured/formPicc',
            name: 'insuredFormPicc',
            component: resolve => require(['../pages/insured/formPicc.vue'], resolve)
        },
        {
            path: '/insured/formAviation',
            name: 'insuredFormAviation',
            component: resolve => require(['../pages/insured/formAviation.vue'], resolve)
        },
        {
            path: '/insured/leukaemiaBaby',
            name: 'insuredLeukaemiaBaby',
            component: resolve => require(['../pages/insured/leukaemiaBaby.vue'], resolve)
        },
        {
            path: '/insured/formTreasure',
            name: 'insuredFormTreasure',
            component: resolve => require(['../pages/insured/formTreasure.vue'], resolve)
        },
        {
            path: '/insured/formOverseasMedical',
            name: 'insuredOverseasMedical',
            component: resolve => require(['../pages/insured/formOverseasMedical.vue'], resolve)
        },
        {
            path: '/insured/formWomen',
            name: 'formWomen',
            component: resolve => require(['../pages/insured/formWomen.vue'], resolve)
        },
        {
            path: '/insured/formHealth',
            name: 'formHealth',
            component: resolve => require(['../pages/insured/formHealth.vue'], resolve)
        },
        {
            path: '/insured/formBase',
            name: 'formBase',
            component: resolve => require(['../pages/insured/formBase.vue'], resolve)
        },
        {
            path: '/insured/form',
            name: 'insuredForm',
            component: resolve => require(['../pages/insured/form.vue'], resolve)
        },
        // 泰康险录入页（家庭版）
        // {
        //     path: '/insured/insureTK',
        //     name: 'insureTK',
        //     component: resolve => require(['../pages/insured/insureTK.vue'], resolve)
        // },
        {
            path: '/insured/insureTK',
            name: 'insureFamily',
            component: resolve => require(['../pages/insured/insureFamily.vue'], resolve)
        },
        // 平安E生产品
        {
            path: '/insured/medicalPingAn',
            name: 'medicalPingAn',
            component: resolve => require(['../pages/insured/medicalPingAn.vue'], resolve)
        },
        // 和泰重疾与试算非相关信息录入页 by 丁延超
        {
            path: '/insured/seriousillness',
            name: 'insuredSeriousillness',
            component: resolve => require(['../pages/insured/seriousillness.vue'], resolve)
        },
        // {   //和泰重疾 信息展示页 by 丁延超
        //     path: '/insured/seriousillness',
        //     name: 'insuredSeriousillness',
        //     component: resolve => require(['../pages/insured/seriousillness.vue'], resolve)
        // },
        {
            path: '/my/modifyPwd',
            name: 'modifyPwd',
            component: resolve => require(['../pages/my/modifyPwd.vue'], resolve)
        },
        {
            path: '/my/myRights',
            name: 'myRights',
            component: resolve => require(['../pages/my/myRights.vue'], resolve)
        },

        {
            path: '/my/policy',
            name: 'myPolicy',
            component: resolve => require(['../pages/my/mypolicy.vue'], resolve)
        },
        {
            path: '/product/twoCodePay',
            name: 'twoCodePay',
            component: resolve => require(['../pages/pay/twoCodePay.vue'], resolve)
        },
        {
            path: '/product/pay',
            name: '/pay',
            component: resolve => require(['../pages/pay/pay.vue'], resolve)
        },
        {
            path: '/product/overseasPay/:id?',
            name: '/overseasPay',
            component: resolve => require(['../pages/pay/overseasPay.vue'], resolve)
        },
        {
            path: '/investDetailFa',
            name: 'investDetailFa',
            component: resolve => require(['../pages/pay/payFail.vue'], resolve),
        },
        // 改版后的支付失败页
        {
            path: '/newInvestDetailFa',
            name: 'newInvestDetailFa',
            component: resolve => require(['../pages/pay/newPayFail.vue'], resolve),
        },
        {
            path: '/investDetailSu',
            name: 'investDetailSu',
            component: resolve => require(['../pages/pay/paySuccess.vue'], resolve),
        },
        // 改版后的支付成功页
        {
            path: '/newInvestDetailSu',
            name: 'newInvestDetailSu',
            component: resolve => require(['../pages/pay/newPaySuccess.vue'], resolve),
        },
        {
            path: '/paySuccessTK',
            name: 'paySuccessTK',
            component: resolve => require(['../pages/pay/paySuccessTK.vue'], resolve),
        },

        {
            path: '/renewalSuccess',
            name: 'renewalSuccess',
            component: resolve => require(['../pages/pay/renewalSuccess.vue'], resolve),
        },
        {
            path: '/settleSuccess',
            name: 'settleSuccess',
            component: resolve => require(['../pages/pay/settleSuccess.vue'], resolve),
        },
        {
            path: '/login',
            name: 'login',
            component: resolve => require(['../pages/login/login.vue'], resolve),
        },
        {
            path: '/login/inputPsw',
            name: 'inputPsw',
            component: resolve => require(['../pages/login/inputPsw.vue'], resolve),
        },
        {
            path: '/register/success',
            name: 'registerSuccess',
            component: resolve => require(['../pages/login/registerSucc.vue'], resolve),
        },
        {
            path: '/forgot',
            name: 'forgot',
            component: resolve => require(['../pages/login/forgot.vue'], resolve),
        },
        {
            path: '/login/verification',
            name: 'verification',
            component: resolve => require(['../pages/login/verification.vue'], resolve),
        },
        {
            path: '/',
            component: resolve => require(['../pages/home/menu.vue'], resolve),
            children: [
                {
                    path: '/',
                    name: 'index',
                    component: resolve => require(['../pages/index/index.vue'], resolve)
                },
                {
                    path: '/articlescrap',
                    name: 'articlescrap',
                    component: resolve => require(['../pages/my/articlescrap.vue'], resolve)
                },
                {
                    path: '/find',
                    name: 'find',
                    component: resolve => require(['../pages/find/find.vue'], resolve)
                },
                {
                    path: '/my',
                    name: 'my',
                    component: resolve => require(['../pages/my/newMy.vue'], resolve)
                },
            ]
        },
        {
            path: '/product/sharePoster',
            name: 'sharePoster',
            component: resolve => require(['../pages/product/sharePoster.vue'], resolve)
        },
        {
            path: '/carGround',
            name: '/carGround',
            component: resolve => require(['../pages/product/carGround.vue'], resolve)
        },
        {
            path: '/product/carEntry',
            name: 'carEntry',
            component: resolve => require(['../pages/product/carEntry.vue'], resolve)
        },
        {
            path: '/productDetail/:code',
            name: 'productDetail',
            component: resolve => require(['../pages/product/productDetail.vue'], resolve),
        },
        {
            path: '/productDetailFl/:code',
            name: 'productDetailFl',
            component: resolve => require(['../pages/product/productDetailTwo.vue'], resolve),
        },
        {
            path: '/newProductDetail/:code',
            name: 'newProductDetail',
            component: resolve => require(['../pages/product/newProductDetail.vue'], resolve),
        },
        {
            path: '/productDetail_puhui/:code',
            name: 'productDetail_puhui',
            component: resolve => require(['../pages/product/productDetailPuHui.vue'], resolve),
        },
        {
            path: '/find/:code',
            name: 'findClass',
            component: resolve => require(['../pages/find/findClass.vue'], resolve)
        },
        {
            path: '/my/link',
            name: 'link',
            component: resolve => require(['../pages/my/link.vue'], resolve)
        },
        {
            path: '/my/linkInfo',
            name: 'linkInfo',
            component: resolve => require(['../pages/my/linkInfo.vue'], resolve)
        },
        {
            path: '/identity',
            name: 'identity',
            component: resolve => require(['../pages/product/identity.vue'], resolve)
        },
        {
            path: '/bridgeUrl',
            name: 'bridgeUrl',
            component: resolve => require(['../pages/bridgeUrl/bridgeUrl.vue'], resolve)
        },
        {
            path: '/kostaNeedBill',
            name: 'kostaNeedBill',
            component: resolve => require(['../pages/kostaNeedBill/kostaNeedBill.vue'], resolve)
        },
        {
            path: '/platform',
            name: 'platform',
            component: resolve => require(['.././components/platform'], resolve)
        },
        {
            path: '/mainClause',
            name: 'mainClause',
            component: resolve => require(['../pages/xcx/mainClause'], resolve)
        },
        {
            path: '/withClause',
            name: 'withClause',
            component: resolve => require(['../pages/xcx/withClause'], resolve)
        },
        {
            path: '/inform',
            name: 'inform',
            component: resolve => require(['../pages/xcx/inform'], resolve)
        },
        {
            path: '/entrust',
            name: 'entrust',
            component: resolve => require(['../pages/xcx/entrust'], resolve)
        },
        {
            path: '/three/aboutus',
            name: 'aboutus',
            component: resolve => require(['../pages/three/aboutus/index.vue'],resolve)
        },
        {
            path: '/three/information',
            name: 'information',
            component: resolve => require(['../pages/three/information/index.vue'],resolve)
        },
        {
            path: '/three/product',
            name: 'product',
            component: resolve => require(['../pages/three/product/index.vue'],resolve)
        },
        {
            path: '/three/claimService',
            name: 'claimService',
            component: resolve => require(['../pages/three/productList/claimService.vue'],resolve)
        },
        // 家政财险
        {
            path: '/claim-service',
            name: 'serviCeclaim',
            component: resolve => require(['../pages/claimService/index.vue'],resolve)
        },
        {
            path: '/toIndex',
            name: 'toIndex',
            component: resolve => require(['../pages/index/toIndex.vue'],resolve)
        },
        {
            path: '/landingPage',
            name: 'landingPage',
            component: resolve => require(['../pages/index/landingPage.vue'],resolve)
        },
        {
            path: '/t/:code',
            name: 't',
        },
    ]
});



router.beforeEach((to, from, next) => {
    // alert(window.location.href);
    if (getQueryString('linkto') && getQueryString('linkto') === '/') {
        sessionStorage['linkto'] = getQueryString('linkto');
    }
    if (getQueryString('wxChannel') === 'gome_xcx') {
        sessionStorage['wxChannel'] = getQueryString('wxChannel');
    }
    // 判断是不是从国美金融APP跳转的
    if (getQueryString('source') === 'app') {
        sessionStorage['source'] = getQueryString('source');
    }
    if (sessionStorage['source'] === 'app' || isSource) {
        // alert(window.location.href);
        let mybsellChannel = getQueryString('mybsellChannel') ||'QD005';
        let sellChannel = getQueryString('sellChannel') || '157310628745091214';
        let platform = getQueryString('platform') ||'20';
        sessionStorage.setItem('accessToken/app',getQueryString('accessToken'));
        storage.set('mybsellChannel', mybsellChannel);
        storage.set('sellChannel', sellChannel);
        storage.set('platform', platform);
    }

    if(getQueryString('appEnv')){
        sessionStorage['appEnv'] = getQueryString('appEnv');
    }
    if(isGomeHome || sessionStorage['appEnv'] === 'gomeHome'){
        document.title = '员工内购专区';
        if(window.location.href==='m.gomelife.com'){
            this.$router.replace('/my');
        }else if(window.location.href==='m-uat.gomelife.com'){
            this.$router.replace('/my');
        }
    }

    //收集链接上的一些需要放到缓存里的参数
    addParamsStorage(to);
    let agentToken = cookieUtils.getCookie('token') || getQueryString('token')||'';
    let agentPassId = getQueryString('mybPassId') || '';
    cookieUtils.delRootCookie('token');
    //从美云宝跳过来代理人置换token
    if (agentPassId) {
        let _this = this;
        // _this.isLoading = true;
        tokenLoginChange(agentPassId).then(res=>{
            // alert(res);
            if (res.success) {
                if(!sessionStorage['isRefresh']){
                    sessionStorage['isRefresh'] = '1';
                    window.location.reload();
                }
            }
            next ();
        });
    }


    // 从哪个平台跳转过来的  myb：美云保平台
    let linkfrom = getQueryString('linkfrom')|| '';
    if (linkfrom === 'myb') {
        // 存储参数
        let mybsellChannel = getQueryString('mybsellChannel') ||'QD005';
        let sellChannel = getQueryString('sellChannel') || golbalConstants.sellChannel;
        let platform = getQueryString('platform') ||'2';
        let mybInviter = getQueryString('mybInviter') || '';
        storage.set('mybsellChannel', mybsellChannel);
        storage.set('sellChannel', sellChannel);
        localStorage['sellChannel'] = sellChannel;
        storage.set('platform', platform);
        storage.set('mybInviter', mybInviter);
    }
    //如果是从美云保跳转过来且存储了美云保passid，若没有登录态，则调用接口进行置换
    if(sessionStorage['linkfrom'] === 'myb' && sessionStorage['mybPassId']){
        isLogin().then(res=>{
            if(!res.success){
                tokenLoginChange(agentPassId);
            }
        });
    }

    //判断是否为短链接
    if (to.name == 't' && to.params.code) {
        getFullPath(to.params.code).then(res => {
            if (res.success) {
                window.location.href = res.data;
            }
        });
    }
    if(localStorage.getItem('inviterOwn') && localStorage.getItem('inviterOwn') !== 'null') {
        storage.set('inviterOwn', localStorage.getItem('inviterOwn'));
    }else {
        localStorage.removeItem('inviterOwn');
    }

    //收集链接上的一些需要放到缓存里的参数
    addParamsStorage(to);
    cookieUtils.delRootCookie('token');
    if (agentToken) {
        tokenChangeLogin(agentToken).then(res => {
            if(res.success){
                if (res.data.idStr) {
                    storage.set('inviterOwn', res.data.idStr);
                    storage.setL('inviterOwn', res.data.idStr);
                    storage.setL('phone',res.data.mobile);
                }
            }
            next();
        });
    } else { //判断是否有微信相关内容
        if (to.query.appToken) {
            getSessionByToken(to.query.appToken);
        }
        if (to.query.accessToken) {
            getSessionByToken(to.query.accessToken);
        }
        const ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') { //判断微信环境
            wxInterceptUtil(to, next);
        } else { //浏览器环境
            normalUtil(to, next);
        }
    }
    // }
});

// router.afterEach((to, from) => {
//     setTimeout(()=>{
//         patchIosBlank();
//     },1000);
// });




//微信环境的拦截
function wxInterceptUtil(to, next) {
    let code = to.query.code || getQueryString('code') || '';
    let wxBindFlag = to.query.wxBindFlag || getQueryString('wxBindFlag') || '';
    let unid = to.query.unid;
    // alert(unid);
    if (wxBindFlag) { //为微信首次绑定
        if(unid){
            wxBindUtilUnionId(code, to, next);
        }else{
            wxBindUtil(code, to, next);
        }
    } else { // 不是首次绑定，直接换取登录态
        wxLoginUtil(code, to, next);
    }
}

//正常拦截
function normalUtil(to, next) {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        isLogin().then(result => { //校验这个目标页面是否需要登录
            if (!result.success) {
                checkLoginUtil(to, next);
            } else {
                next();
            }
        });
    } else {
        next();
    }

}

// 微信绑定网站账户辅助方法openid
function wxBindUtil(code, to, next) {
    wechatOpenid(code).then(function (result) {
        next(); //因为授权登录成功
    });
}

// 微信绑定网站账户辅助方法UnionId
function wxBindUtilUnionId(code, to, next) {
    wechatUnionId(code).then(function (result) {
        next(); //因为授权登录成功
    });
}

//微信授权登录辅助方法
function wxLoginUtil(code, to, next) {
    if (code) {
        wechatLogin(code).then(function (result) { // 微信登录
            console.log(result);
            if (result && result.success) {
                addLoginStore(result);
                next();
            } else {
                checkLoginUtil(to, next);
            }
        });
    } else { //没有code，那就是正常微信页面,正常微信页面也需要判断下登录态
        normalUtil(to, next);
    }
}

/**
 * 登录的一个辅助方法
 * @param { } to
 * @param {*} next
 */
function checkLoginUtil(to, next, type) {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        next({
            path: '/login/passUnify',
            query: {
                redirect: to.fullPath
            }
        });
    } else {
        next();
    }
}


/**
 * 增加缓存
 * @param {*} result
 */
function addLoginStore(result) {
    storage.setL('ccat', true);
    storage.setL('userId', result.data.userId);
    storage.setL('mobile', result.data.userMobile);
    storage.setL('headImgUrl', result.data.headImgUrl);
    storage.setL('nickName', result.data.nickName);
    if(result.data.userId) {
        storage.setL('inviterOwn', result.data.userId);
        storage.set('inviterOwn', result.data.userId);
    }
}

/**
 * 将链接里的参数加入缓存
 * @param {*} to
 */
function addParamsStorage(to) {
    if (to.query) {
        Object.keys(to.query).forEach((keys) => {
            to.query[keys] ? storage.set(keys, to.query[keys]) : '';
        });
    }
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js